import React from 'react';
import clsx from 'clsx';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledRadioGroup = styled(RadioGroup)({
    display: 'inline',
    marginLeft: '3px'
});

const StyledRadio = styled(Radio)({
    padding: '5px',
    color:"#6EA0D7"
});

const RadioButton = (props) => {
    let { radioGroupClass, formControlClass, name, valueRadioGroup, onChange, extraOnChange,radioClassA, radioClassB,
        radioColorA = 'default', radioColorB = 'default', labelA, labelB, valueA, valueB, labelPlacementA, labelPlacementB,
        isRadioADisabled = false, isRadioBDisabled = false,
    } = props;

    return (
        <StyledRadioGroup disabled={true} className={clsx(radioGroupClass)} name={name} value={valueRadioGroup} onChange={event => onChange(event, extraOnChange)}>
            <FormControlLabel
                className={formControlClass}
                control={<StyledRadio className={clsx(radioClassA)} color={radioColorA} disabled={isRadioADisabled}/>}
                label={labelA}
                value={valueA}
                labelPlacement={labelPlacementA}
            />
            <FormControlLabel
                className={formControlClass}
                control={<StyledRadio className={clsx(radioClassB)} color={radioColorB} disabled={isRadioBDisabled}/>}
                label={labelB}
                value={valueB}
                labelPlacement={labelPlacementB}
            />
        </StyledRadioGroup>
    )
};

export default RadioButton;